import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/App";
import { LayoutDashboard, Package, AlertCircle, ShoppingBag, Film, ShieldCheck, Store, BarChart3, Crown } from "lucide-react";
import { PanelShell } from "./PanelShell";

const MENU = [
  { icon: LayoutDashboard, label: "Dashboard", path: "/seller/dashboard" },
  { icon: Package, label: "Products", path: "/seller/products" },
  { icon: Store, label: "Store Builder", short: "Store", path: "/seller/store-settings" },
  { icon: BarChart3, label: "Analytics", path: "/seller/analytics" },
  { icon: Film, label: "Reels", path: "/seller/reels" },
  { icon: Crown, label: "Plans", path: "/seller/plans" },
  { icon: ShieldCheck, label: "KYC", path: "/seller/kyc" },
];

const SellerLayout = ({ children, title }) => {
  const { user } = useAuth();
  return (
    <PanelShell
      badge="Seller Panel"
      menuItems={MENU}
      testIdFor={(i) => `seller-nav-${i.label.toLowerCase().replace(/\s+/g, "-")}`}
      logoutTestId="logout-btn"
      title={title}
      headerRight={
        <>
          {!user?.is_approved && (
            <span className="inline-flex items-center text-[11px] font-bold bg-white/15 text-secondary-300 rounded-full px-3 py-1" data-testid="seller-pending-badge">
              <AlertCircle className="w-3 h-3 mr-1" />Pending
            </span>
          )}
          <span className="hidden md:block text-sm font-bold text-white truncate max-w-[180px]">{user?.business_name}</span>
        </>
      }
      sidebarExtra={
        user?.store_slug && (
          <Link to={`/store/${user.store_slug}`} target="_blank" className="flex items-center gap-3 px-4 py-3 rounded-2xl text-primary-100 hover:bg-white/10 font-semibold" data-testid="seller-view-store-link">
            <ShoppingBag className="w-5 h-5" />View Store
          </Link>
        )
      }
    >
      {children}
    </PanelShell>
  );
};

export default SellerLayout;
